/**
 * @generated SignedSource<<3d1b18c92ab46f5839a4ee54bc6c1b77>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FiltersModal_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ScheduleSwitcher_session">;
  readonly " $fragmentType": "FiltersModal_session";
};
export type FiltersModal_session$key = {
  readonly " $data"?: FiltersModal_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"FiltersModal_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FiltersModal_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ScheduleSwitcher_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "7657faedd5b8452c1c2d699b919a0078";

export default node;
